module.exports = __webpack_public_path__ + "static/media/idMIXxx8N__1770238083141.6e2ac519.jpeg";